import { URL_PUBLIQUE } from '../plateforme';
import { useState } from 'react';
import { relancerRencontre, relancerEntrainement, getCurrentUser, getEquipeCourante } from '../api';
import { texteConvocation } from '../texteWhatsApp';

/** Sous le détail d'un match ou d'un entraînement : copier pour WhatsApp, et relancer les sans-réponse. */
export default function ActionsConvocation({ type, ev, peutRelancer, onToast }) {
  const [texteVisible, setTexteVisible] = useState(null);
  const [relance, setRelance] = useState(false);
  const user = getCurrentUser();
  const equipe = (user?.equipes || []).find(e => e.id === getEquipeCourante())?.nom;
  const texte = texteConvocation(type, ev, { equipe, lien: `${URL_PUBLIQUE}/?convocations` });
  const sansReponse = (ev.presences || []).filter(p => p.convoque !== 0 && !p.repondu && !p.excuse).length;

  const copier = async () => {
    try { await navigator.clipboard.writeText(texte); onToast?.('Copié : collez-le dans le groupe WhatsApp'); }
    catch { setTexteVisible(texte); }       // presse-papiers indisponible : on montre le texte à sélectionner
  };
  const partager = async () => { try { await navigator.share({ text: texte }); } catch { /* partage annulé */ } };
  const lancerRelance = async () => {
    if (!window.confirm(`Relancer ${sansReponse} joueur${sansReponse > 1 ? 's' : ''} sans réponse ? Une notification et un email leur seront envoyés.`)) return;
    setRelance(true);
    try {
      const r = await (type === 'rencontre' ? relancerRencontre : relancerEntrainement)(ev.id);
      onToast?.(`${r.relances} joueur${r.relances > 1 ? 's' : ''} relancé${r.relances > 1 ? 's' : ''}${r.injoignables?.length ? ` · sans notification ni email : ${r.injoignables.join(', ')}` : ''}`);
    } catch (e) { onToast?.(e.message, 'error'); }
    setRelance(false);
  };
  const bouton = { width: 'auto', padding: '7px 12px', fontSize: 12.5 };
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button type="button" className="btn btn-secondary" style={bouton} onClick={copier}>📋 Copier pour WhatsApp</button>
        {typeof navigator !== 'undefined' && navigator.share && <button type="button" className="btn btn-secondary" style={bouton} onClick={partager}>📤 Partager</button>}
        {peutRelancer && (
          <button type="button" className="btn btn-secondary" style={bouton} disabled={!sansReponse || relance} onClick={lancerRelance}>
            {relance ? 'Relance…' : sansReponse ? `🔔 Relancer les ${sansReponse} sans réponse` : '🔔 Tout le monde a répondu'}</button>)}
      </div>
      {texteVisible && (
        <textarea readOnly value={texteVisible} aria-label="Texte à copier" onFocus={e => e.target.select()}
                  style={{ width: '100%', boxSizing: 'border-box', minHeight: 160, marginTop: 10, fontSize: 12.5, background: 'var(--bg)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 8, padding: 8 }} />)}
    </div>);
}
